import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface KPITooltipProps {
	text: string;
}

export function KPITooltip({ text }: KPITooltipProps) {
	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<HelpCircle className="h-4 w-4 text-muted-foreground cursor-help shrink-0" />
				</TooltipTrigger>
				<TooltipContent className="max-w-[260px] text-sm">
					{text}
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
}
